import { get } from 'lodash';
import { BLOG_APP_ID } from '@wix/communities-universal/dist/src/constants/appsConfig';
import { ROLE_WRITER } from '@wix/communities-blog-universal/dist/src/permissions-checker-constants';

export const getUserRoleByApp = (user, appDefinitionId) =>
  get(user, `appStore[${appDefinitionId}].permissions.role`);
export const getUserRole = (user) => getUserRoleByApp(user, BLOG_APP_ID);
export const isWriter = (user) => getUserRole(user) === ROLE_WRITER;
